export const PLAN_TYPES = {
  FREE: 'free',
  PREMIUM: 'premium',
  FAMILY: 'family',
};

export const FEATURE_KEYS = {
  CONTRACT_ALERTS: 'contract_alerts',
  ADVANCED_INSIGHTS: 'advanced_insights',
  GROCERY_OPTIMIZATION: 'grocery_optimization',
  MULTIPLE_GOALS: 'multiple_goals',
  SCENARIO_SIMULATOR: 'scenario_simulator',
};

const PREMIUM_FEATURES = new Set([
  FEATURE_KEYS.CONTRACT_ALERTS,
  FEATURE_KEYS.ADVANCED_INSIGHTS,
  FEATURE_KEYS.GROCERY_OPTIMIZATION,
  FEATURE_KEYS.MULTIPLE_GOALS,
  FEATURE_KEYS.SCENARIO_SIMULATOR,
]);

export const getUserPlan = (user) => {
  if (user?.plan_type && Object.values(PLAN_TYPES).includes(user.plan_type)) {
    return user.plan_type;
  }

  return user?.is_premium ? PLAN_TYPES.PREMIUM : PLAN_TYPES.FREE;
};

export const hasPremiumAccess = (featureKey, user) => {
  if (!PREMIUM_FEATURES.has(featureKey)) {
    return true;
  }

  const planType = getUserPlan(user);
  return planType === PLAN_TYPES.PREMIUM || planType === PLAN_TYPES.FAMILY;
};
